import { render, staticRenderFns } from "./MaterialData.vue?vue&type=template&id=835025ea&scoped=true&"
import script from "./MaterialData.vue?vue&type=script&lang=js&"
export * from "./MaterialData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835025ea",
  null
  
)

export default component.exports